import * as React from 'react';
import {Meteor} from 'meteor/meteor';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab, {TabProps} from '@material-ui/core/Tab';
import {NavLink} from 'react-router-dom';

import routerUrls from 'client/constants/routerUrls';
import './AdminHeader.scss';
import {LL} from 'shared/localization';

interface IAdminHeaderState {
	selectedMenu: string;
}

interface ILinkTabProps extends TabProps {
	to: string;
}

const LinkTab = (props: ILinkTabProps) => {
	return <Tab component={NavLink} {...props} />;
};

class AdminHeader extends React.PureComponent<{}, IAdminHeaderState> {
	state = {
		selectedMenu: 'users',
	};

	handleLogout = () => {
		Meteor.logout();
	};

	onTabChange = (e: object, selectedMenu: string) => {
		if (!selectedMenu) return;
		this.setState({selectedMenu});
	};

	render() {
		const {selectedMenu} = this.state;

		return (
			<AppBar className="adminHeader" position="fixed">
				<div className="container">
					<Toolbar className="toolbar" variant="dense">
						<div className="menuAndHeader">
							<Typography variant="h6" color="inherit" className="logo">
								<a href={routerUrls.adminHome}>
									{LL('common.adminHeader.controlPanel')}
								</a>
							</Typography>

							<Tabs
								variant="fullWidth"
								value={selectedMenu}
								onChange={this.onTabChange}
							>
								<LinkTab
									value="users"
									key="users"
									to={routerUrls.adminUsers}
									label={LL('common.adminHeader.users')}
								/>
								<LinkTab
									value="apps"
									key="apps"
									to={routerUrls.adminApps}
									label={LL('common.adminHeader.apps')}
								/>
								<LinkTab
									value="paidServices"
									key="paidServices"
									to={routerUrls.adminServices}
									label={LL('common.adminHeader.services')}
								/>
								<LinkTab
									value="surveys"
									key="surveys"
									to={routerUrls.adminSurveys}
									label={LL('common.adminHeader.surveys')}
								/>
								<LinkTab
									value="news"
									key="news"
									to={routerUrls.adminNews}
									label={LL('common.adminHeader.news')}
								/>
								<Tab
									value="logout"
									key="logout"
									onClick={this.handleLogout}
									label={LL('common.exit')}
								/>
							</Tabs>
						</div>
					</Toolbar>
				</div>
			</AppBar>
		);
	}
}

export default AdminHeader;
